import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import '@/styles/index.scss' // global css
import 'animate.css';
import api from './request/api'
import moment from 'moment'
import global from '@/utils/common.js'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
// 全局挂载
Vue.use(VueAwesomeSwiper)

Vue.config.productionTip = false
Vue.prototype.$api = api; // 将api挂载到vue的原型上
Vue.prototype.$moment = moment
Vue.prototype.$global = global

/* router.beforeEach((to, from, next) => {
  //to（当前页面） form（前一页面）
  //判断当前页是不是目标页，再判断前一页面是否要缓存
  if (to.name == 'newsContent' && from.name == 'news') {
     from.meta.keepAlive = true;
  }else {
     from.meta.keepAlive = false;
  }
  next();
}); */


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
